import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SynchronizationConfiguration, SynchronizationTaskHistory} from './synchronization.reducer';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SynchronizationClientService {

  constructor(private http: HttpClient) {
  }

  fetchConfigurations(): Observable<SynchronizationConfiguration[]> {
    return this.http.get<SynchronizationConfiguration[]>(`${environment.apiSegments}/sync`);
  }

  fetchTaskHistories(configurationId: string): Observable<SynchronizationTaskHistory[]> {
    return this.http.get<SynchronizationTaskHistory[]>(`${environment.apiSegments}/sync/history/${configurationId}`);
  }

  scheduleSynchronization(id: string): Observable<any> {
    return this.http.post<any>(`${environment.apiSegments}/sync/${id}`, {});
  }

  createNewConfiguration(newConfiguration: SynchronizationConfiguration): Observable<SynchronizationConfiguration> {
    return this.http.post<SynchronizationConfiguration>(`${environment.apiSegments}/sync`, newConfiguration);
  }
}
